module.exports = __webpack_public_path__ + "img/Group4.de7cdecf.jpg";